module.exports = __webpack_public_path__ + "components/flag/static/square/ie-dac9f4495b389b761fdd6457460f8401.svg";